import { changeLanguage } from "@services/Language";
import { secureStorage, StorageKeys } from "@services/secureStorage.service";
import { store } from "@store/index";
import { clearAuthError } from "@store/slices/authError";
import { validateLanguage } from "@utilities/appUtils";
import { useEffect } from "react";

import { EVENTS_TYPES } from "./useParentCommunication";

/**
 * Listens for runtime updates from parent (language, JWT changes)
 * Applies changes directly to storage without triggering re-renders
 */
export const useRuntimeUpdates = (): void => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === EVENTS_TYPES.UPDATE_LANGUAGE && event.data?.language) {
        const validLanguage = validateLanguage(event.data.language);
        secureStorage.set(StorageKeys.LANGUAGE, validLanguage);
        changeLanguage(validLanguage);
      }
      
      if (event.data?.type === EVENTS_TYPES.UPDATE_JWT && event.data?.jwt) {
        secureStorage.set(StorageKeys.JWT, event.data.jwt);
        // Clear auth error state so the app will work again on retry
        // Note: We intentionally do NOT reset API state here to avoid unnecessary refetches
        store.dispatch(clearAuthError());
      }
    };

    globalThis.addEventListener("message", handleMessage);
    return () => globalThis.removeEventListener("message", handleMessage);
  }, []);
};

